import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { FlexProps, RowProps } from "../types";
import Flex from "./flex-root";

function FlexRow<E extends React.ElementType = "div">({
  as,
  asChild = false,
  reverse = false,
  justify = "start",
  items = "start",
  className,
  ...props
}: RowProps<E>) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Flex.Row] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }
  return (
    <Flex
      as={as}
      asChild={asChild}
      direction={reverse ? "row-reverse" : "row"}
      justify={justify}
      items={items}
      className={cn(className, classes)}
      {...(native as FlexProps<E>)}
    />
  );
}

FlexRow.displayName = "Flex.Row";

export default FlexRow;
